import { Button } from '@/view/components/ui/button'

interface ConfirmButtonProps {
  disabled: boolean
}
export const ConfirmButton = ({ disabled }: ConfirmButtonProps) => (
  <Button
    disabled={disabled}
    type="submit"
    className="w-full rounded-full text-lg font-semibold text-white"
  >
    Confirmar
  </Button>
)
